<template>
    <div class="app_container">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="党性分析" name="first">
                <div>
                    <img src="../../../assets/image/jiaxing/9.png" alt />
                </div>
            </el-tab-pane>
            <el-tab-pane label="理论学习" name="second">
                <img src="../../../assets/image/jiaxing/10.png" alt />
            </el-tab-pane>
            <el-tab-pane label="理论学习成绩单" name="third">
                <img src="../../../assets/image/jiaxing/11.png" alt />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
        activeName: 'first'
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  };
</script>

<style scoped>

</style>
